 // function toggleFaq(btn) {
 //    const allItems = document.querySelectorAll('.faq-item');
 //    const item = btn.closest('.faq-item');
 //    const content = item.querySelector('.faq-answer');
 //    allItems.forEach(faq => {
 //      const answer = faq.querySelector('.faq-answer');
 //      if (faq !== item) {
 //        faq.classList.remove('open');
 //        answer.style.height = '0px';
 //      }
 //    });
 //    if (item.classList.contains('open')) {
 //      item.classList.remove('open');
 //      content.style.height = '0px';
 //    } else {
 //      item.classList.add('open');
 //      content.style.height = content.scrollHeight + 'px';
 //    }
 //  }
 //  document.addEventListener('DOMContentLoaded', () => {
 //    const openItem = document.querySelector('.faq-item.open .faq-answer');
 //    if (openItem) {
 //      openItem.style.height = openItem.scrollHeight + 'px';
 //    }
 //  });


function toggleFaq(btn) {
  const allItems = document.querySelectorAll('.faq-item');
  const item = btn.closest('.faq-item');
  const content = item.querySelector('.faq-answer');

  allItems.forEach(faq => {
    const answer = faq.querySelector('.faq-answer');
    if (faq !== item) {
      faq.classList.remove('open');
      answer.style.height = '0px';
    }
  });

  if (item.classList.contains('open')) {
    item.classList.remove('open');
    content.style.height = content.scrollHeight + 'px';
    requestAnimationFrame(() => {
      content.style.height = '0px'; 
    });
  } else {
    item.classList.add('open');
    content.style.height = 'auto';
    const height = content.scrollHeight + 'px';
    content.style.height = '0px'; 
    requestAnimationFrame(() => {
      content.style.height = height;
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const openItem = document.querySelector('.faq-item.open .faq-answer');
  if (openItem) {
    openItem.style.height = openItem.scrollHeight + 'px';
  }
});
